export enum ConeCrusherCSTypes {
  CS420 = 'CS420',
  CS430 = 'CS430',
  CS440 = 'CS440',
  CS660 = 'CS660',
  CS840i = 'CS840i',
}
